export default __webpack_public_path__ + "img/team-mascotte-greentic.747f32d0.svg";